<template>
    <div>
        <div v-if="loading" class="mt-5 mb-5">
            <spinner position="center"></spinner>
        </div>
        <form v-if="client" v-show="!loading" id="creditParamsForm" ref="creditParamsForm" method="POST"
              class="ang-card-body"
              :action="action">
            <input type="hidden" name="data[step_4]" value="1" />
          <input type="hidden" name="code" :value="code" />
            <div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <p class="ang-card-title mt-3">Cel i parametry kredytu</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-8">
                      <div class="form-group">
                        <label class="ang-form-label">Cel kredytu</label>
                        <select-field name="data[credit][loan_purpose]" css="width: 100%" :search="true" :options="dictionary.loanPurpose" @changed="refreshForm" placeholder="Wybierz" v-model="client.data.credit.loan_purpose" :selected="client.data.credit.loan_purpose">
                        </select-field>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label">System spłaty rat</label>
                            <select-field name="data[credit][instalments_type]" css="width: 100%" placeholder="Wybierz" @changed="refreshForm"
                                          :options="{values: [{val: 'Równe', text: 'Równe'}, {val: 'Malejące', text: 'Malejące'}]}"
                                          v-model="client.data.credit.instalments_type" :selected="client.data.credit.instalments_type"></select-field>
                        </div>
                    </div>
<!--                    <div class="col-12 col-md-4">-->
<!--                        <div class="form-group">-->
<!--                            <label class="ang-form-label">Uruchamianie</label>-->
<!--                            <select-field name="data[credit][release_type]" css="width: 100%" placeholder="Wybierz"-->
<!--                                          :options="{values: [{val: 'Jednorazowe', text: 'Jednorazowe'}, {val: 'Transze', text: 'Transze'}]}"-->
<!--                                          v-model="client.data.credit.release_type" :selected="client.data.credit.release_type"></select-field>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label">Wkład własny wniesiony (PLN)</label>
                            <currency-field name="data[credit][own_part_value]" :notrequired="true"
                                            v-model="client.data.credit.own_part_value"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label">Wkład własny do wniesienia (PLN)</label>
                            <currency-field name="data[credit][own_part_value_future]" :notrequired="true"
                                            v-model="client.data.credit.own_part_value_future"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="period">Okres kredytowania (miesiące)</label>
                            <input type="text" class="ang-form-control dig" id="period" name="data[credit][period]"
                                   v-model="client.data.credit.period">
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="instalment_day">Dzień (miesiąca) płatności raty</label>
                            <input type="text" class="ang-form-control dig" id="instalment_day" max="31" min="1" name="data[credit][instalment_day]"
                                   v-model="client.data.credit.instalment_day">
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label">Prowizja za udzielenie kredytu</label>
                            <select-field name="data[credit][commission]" css="width: 100%" placeholder="Wybierz" @changed="refreshForm"
                                          :options="{values: [{val: 'Kredytowana (o ile bank pozwala)', text: 'Kredytowana (o ile bank pozwala)'}, {val: 'Niekredytowana', text: 'Niekredytowana'}]}"
                                          v-model="client.data.credit.commission" :selected="client.data.credit.commission"></select-field>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12">
                        <p class="ang-card-title mt-3">Kwota kredytu</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="buy_property_amount">Zakup nieruchomości</label>
                            <currency-field name="data[credit][buy_property_amount]" id="buy_property_amount" :notrequired="true"
                                            v-model="client.data.credit.buy_property_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" v-if="client.data.credit.buy_property_amount && client.data.credit.buy_property_amount.length > 0">
                        <div class="form-group">
                            <label class="ang-form-label">Rynek zakupu nieruchomości</label>
                            <select-field name="data[credit][market_type]" css="width: 100%" placeholder="Wybierz" @changed="refreshForm"
                                          :options="{values: [{val: 'Rynek pierwotny', text: 'Rynek pierwotny'}, {val: 'Rynek wtórny', text: 'Rynek wtórny'}]}"
                                          v-model="client.data.credit.market_type" :selected="client.data.credit.market_type"></select-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="house_build_amount">Budowa domu</label>
                            <currency-field name="data[credit][house_build_amount]" id="house_build_amount" :notrequired="true"
                                            v-model="client.data.credit.house_build_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="renew_amount">Remont/adaptacja/wykończenie</label>
                            <currency-field name="data[credit][renew_amount]" id="renew_amount" :notrequired="true"
                                            v-model="client.data.credit.renew_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="refinance_amount">Refinansowanie kredytu mieszkaniowego</label>
                            <currency-field name="data[credit][refinance_amount]" id="refinance_amount" :notrequired="true"
                                            v-model="client.data.credit.refinance_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="consolidation_amount">Konsolidacja</label>
                            <currency-field name="data[credit][consolidation_amount]" id="consolidation_amount" :notrequired="true"
                                            v-model="client.data.credit.consolidation_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="loan_amount">Pożyczka hipoteczna</label>
                            <currency-field name="data[credit][loan_amount]" id="loan_amount" :notrequired="true"
                                            v-model="client.data.credit.loan_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="other_amount">Inny (kwota)</label>
                            <currency-field name="data[credit][other_amount]" id="other_amount" :notrequired="true"
                                            v-model="client.data.credit.other_amount" @keyup="calcAmounts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" v-if="client.data.credit.other_amount && client.data.credit.other_amount.length > 0">
                        <div class="form-group">
                            <label class="ang-form-label" for="other_desc">Inny (opis)</label>
                            <input type="text" class="ang-form-control" id="other_desc" name="data[credit][other_desc]"
                                   v-model="client.data.credit.other_desc">
                        </div>
                    </div>
                    <div class="col-12 col-md-4" >
                        <div class="form-group">
                            <label class="ang-form-label" for="amount_sum">Suma</label>
                            <currency-field name="data[credit][amount_sum]" id="amount_sum" :disabled="true"
                                            v-model="client.data.credit.amount_sum"></currency-field>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <p class="ang-card-title mt-3">Koszt inwestycji</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="price">Cena zakupu</label>
                            <currency-field name="data[credit][price]" id="price" :notrequired="true"
                                            v-model="client.data.credit.price" @keyup="calcCosts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="garage_price">Cena garażu</label>
                            <currency-field name="data[credit][garage_price]" id="garage_price" :notrequired="true"
                                            v-model="client.data.credit.garage_price" @keyup="calcCosts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="build_cost">Koszt budowy</label>
                            <currency-field name="data[credit][build_cost]" id="build_cost" :notrequired="true"
                                            v-model="client.data.credit.build_cost" @keyup="calcCosts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="renew_cost">Koszt remontu/adaptacji/wykończenia</label>
                            <currency-field name="data[credit][renew_cost]" id="renew_cost" :notrequired="true"
                                            v-model="client.data.credit.renew_cost" @keyup="calcCosts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label class="ang-form-label" for="land_value">Wartość działki (przy budowie domu)</label>
                            <currency-field name="data[credit][land_value]" id="land_value" :notrequired="true"
                                            v-model="client.data.credit.land_value" @keyup="calcCosts"></currency-field>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" >
                        <div class="form-group">
                            <label class="ang-form-label" for="cost_sum">Suma</label>
                            <currency-field name="data[credit][cost_sum]" id="cost_sum" :disabled="true"
                                            v-model="client.data.credit.cost_sum"></currency-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
                <h5 class="ang-card-title">Wystąpił błąd!</h5>
                <label class="form-error error">{{error}}</label>
            </div>
            <div class="d-flex">
                <div>
                    <button class="btn ang-button _bg_color3 mt-1" @click.stop.prevent="$emit('backward')">Wstecz</button>
                </div>
                <div class="ml-auto">
                    <spinner v-if="sending"></spinner>
                    <button v-else type="submit" class="btn btn-lg  ang-button ang-btn-lg spinn">Dalej</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ajax from '@/services/ajax'
import spinner from "@/components/partials/misc/spinner"
import select from "@/components/partials/misc/select"
import currency from "@/components/partials/misc/currency"
import dictionary from '@/services/dictionary'
import $ from 'jquery'

export default {
  data () {
    return {
      success: false,
      error: null,
      sending: false,
      loading: true,
      client: null
    }
  },
  props: ['base_client', 'base', 'code'],
  components: {
    spinner,
    'select-field': select,
    'currency-field': currency
  },
  mixins: [dictionary],
  watch: {
    base_client () {
      let self = this
      this.client = this.base_client
      this.$nextTick(function () {
        self.loading = false
      })
    }
  },
  name: 'creditForm',
  computed: {
    action () {
      return '/client/details/' + this.base
    }
  },
  mounted () {
    let self = this
    this.client = this.base_client
    if (typeof this.client.data.credit === 'undefined') {
      this.client.data.credit = {}
    }
    this.$nextTick(function () {
      self.loading = false
      ajax.postValidate($(self.$refs.creditParamsForm), self, function (form, vm, data) {
        self.sending = false
        self.$emit('forward', data)
      }, function (data) {
        self.error = data.message
        self.sending = false
        $('html,body').animate({scrollTop: $(document).height()}, 'slow')
      }, function () {
        self.error = null
        self.sending = true
      })
    })
  },
  methods: {
    refreshForm () {
      this.calcAmounts()
      this.calcCosts()
      this.$forceUpdate()
    },
    calcAmounts () {
      this.client.data.credit.amount_sum = 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.buy_property_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.buy_property_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.house_build_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.house_build_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.renew_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.renew_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.refinance_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.refinance_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.consolidation_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.consolidation_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.loan_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.loan_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum += !Number.isNaN(parseFloat((this.client.data.credit.other_amount + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.other_amount + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.amount_sum = (this.client.data.credit.amount_sum + '').replace(".", ",")
      this.$forceUpdate()
    },
    calcCosts () {
      this.client.data.credit.cost_sum = 0
      this.client.data.credit.cost_sum += !Number.isNaN(parseFloat((this.client.data.credit.garage_price + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.garage_price + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.cost_sum += !Number.isNaN(parseFloat((this.client.data.credit.price + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.price + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.cost_sum += !Number.isNaN(parseFloat((this.client.data.credit.build_cost + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.build_cost + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.cost_sum += !Number.isNaN(parseFloat((this.client.data.credit.renew_cost + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.renew_cost + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.cost_sum += !Number.isNaN(parseFloat((this.client.data.credit.land_value + '').replace(/\s+/g, '').replace(/,/g, '.'))) ? parseFloat((this.client.data.credit.land_value + '').replace(/\s+/g, '').replace(/,/g, '.')) : 0
      this.client.data.credit.cost_sum = (this.client.data.credit.cost_sum + '').replace(".", ",")
      this.$forceUpdate()
    },
    scrollToAnchor (aid) {
      let aTag = $("#" + aid)
      if (typeof aTag !== 'undefined' && typeof aTag.offset() !== 'undefined') {
        $('html,body').animate({scrollTop: aTag.offset().top - 160}, 'slow')
      }
    }
  }

}
</script>
